import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Link } from "react-router-dom";

const Profile = () => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [username, setUsername] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errors, setErrors] = useState({});

  const validatePassword = (password) => {
    // At least 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character
    const re =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,200}$/;
    return re.test(password);
  };

  const validate = () => {
    const newErrors = {};

    if (!username.trim()) {
      newErrors.username = "Username is required.";
    } else if (username.length < 3) {
      newErrors.username = "Username must be at least 3 characters.";
    }

    if (!currentPassword) {
      newErrors.currentPassword = "Current Password is required.";
    } else if (currentPassword.length < 8) {
      newErrors.currentPassword = "Current must be at least 8 characters.";
    }

    if (!newPassword) {
      newErrors.newPassword = "New Password is required.";
    } else if (newPassword.length < 8) {
      newErrors.newPassword = "New Password must be at least 8 characters.";
    } else if (!validatePassword(newPassword)) {
      newErrors.newPassword =
        "Password must be at least 8 characters with 1 uppercase, 1 lowercase, and 1 number.";
      //isValid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required.";
    } else if (confirmPassword !== newPassword) {
      newErrors.confirmPassword =
        "Confirm Password does not match New Password.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (validate()) {
      // Proceed with saving logic
      //alert('Password updated successfully!');
      // Show success message
      setShowSuccess(true);
      // Hide success message after 3 seconds
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    }
  };

  return (
    <main className="main-content">
       {/* Success Message Popup */}
       {showSuccess && (
          <div className="fixed top-4 right-4 z-50 animate-fade-in">
            <div className="bg-[#635BFF] text-white px-4 py-2 rounded-lg shadow-lg flex items-center">
              <span className="material-symbols-outlined mr-2">check_circle</span>
              Profile Updated successfully!
            </div>
          </div>
        )}
      {/* Main Content */}
      <div class="mb-6 flex flex-wrap items-center justify-between ml-4">
        <h2 class="text-xl font-semibold text-gray-800 ">
          Profile
        </h2>

        <nav>
          <ol class="flex items-center gap-1.5 mr-7">
            <li>
              <Link
                class="inline-flex items-center gap-1.5 text-sm text-black "
                to="/dashboard"
              >
                Home /
              </Link>
            </li>
            <li class="text-sm text-gray-800 ">Profile</li>
          </ol>
        </nav>
      </div>

      <div className="max-w-lg mx-auto p-5 bg-white  rounded-2xl border border-gray-200  shadow-lg">
        <h2 className="w-full text-xl font-semibold text-white bg-[#635BFF] rounded-lg py-2 px-4 flex justify-center">
          PROFILE
        </h2>
        <hr></hr>

        <div className="mb-4 mt-6">
          <label className="block text-sm font-medium text-gray-700  mb-1">
            Name<span className="text-red-500">*</span>
          </label>
          <input
            className={`w-full p-2 border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm ${
              errors.username
                ? "border-[#DC2626] focus:ring-[#DC2626]"
                : "focus:ring-[#635BFF]"
            }`}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            //onBlur={validateUsername}
            placeholder="Enter your username"
            maxLength="150"
          />
          {errors.username && (
            <p className="text-red-500 text-xs mt-1">{errors.username}</p>
          )}
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700  mb-1">
            Email
          </label>
          <input className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#635BFF] placeholder:text-sm" 
          placeholder="Info@gmail.com"          
          readOnly />
        </div>
        <h5 className="text-xs font-semibold sidebar-heading mb-2 uppercase mt-10">
          Change Password
        </h5>
        <hr />

        <div className="mb-4 mt-3">
          <label className="block text-sm font-medium text-gray-700  mb-1">
            Current Password<span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              type={showCurrentPassword ? "text" : "password"}
              className={`w-full p-2 border rounded-lg focus:outline-none focus:ring-2 pr-10 placeholder:text-sm ${
                errors.currentPassword
                  ? "border-[#DC2626] focus:ring-[#DC2626]"
                  : "focus:ring-[#635BFF]"
              }`}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              maxLength="150"
              placeholder="Enter your Current Password"
            />
            <span
              className="absolute right-3 top-3 cursor-pointer text-gray-600 "
              onClick={() => setShowCurrentPassword(!showCurrentPassword)}
            >
              {showCurrentPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>
          {errors.currentPassword && (
            <p className="text-red-500 text-xs mt-1">
              {errors.currentPassword}
            </p>
          )}
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700  mb-1">
            New Password<span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              type={showNewPassword ? "text" : "password"}
              className={`w-full p-2 border rounded-lg focus:outline-none focus:ring-2 pr-10 placeholder:text-sm ${
                errors.newPassword
                  ? "border-[#DC2626] focus:ring-[#DC2626]"
                  : "focus:ring-[#635BFF]"
              }`}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              maxLength="150"
              placeholder="Enter Your New Password"
            />
            <span
              className="absolute right-3 top-3 cursor-pointer text-gray-600 "
              onClick={() => setShowNewPassword(!showNewPassword)}
            >
              {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>
          {errors.newPassword && (
            <p className="text-red-500 text-xs mt-1">{errors.newPassword}</p>
          )}
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700  mb-1">
            Confirm Password<span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              className={`w-full p-2 border rounded-lg focus:outline-none focus:ring-2 pr-10 placeholder:text-sm ${
                errors.confirmPassword
                  ? "border-[#DC2626] focus:ring-[#DC2626]"
                  : "focus:ring-[#635BFF]"
              }`}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              maxLength="150"
              placeholder="Enter Your Confirm Password"
            />
            <span
              className="absolute right-3 top-3 cursor-pointer text-gray-600 "
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>
          {errors.confirmPassword && (
            <p className="text-red-500 text-xs mt-1">
              {errors.confirmPassword}
            </p>
          )}
        </div>

        <button
          className="bg-[#635BFF] text-white px-4 py-2 rounded-lg shadow-lg hover:bg-[#4a28aa] transition w-full"
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </main>
  );
};

export default Profile;
